import { Directive, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Directive({
    selector: '[disableForm]',
    standalone: true,
})
export class DisableFormDirective implements OnChanges, OnDestroy {
    @Input() disableForm: { state: boolean, form: FormGroup };
    private statusChangeSubscription: Subscription;
    private destroy$ = new Subject<void>();

    constructor(private fg: FormGroupDirective) { }

    ngOnInit(): void {
        // Subscribe to new form status changes
        this.statusChangeSubscription = this.disableForm.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
            //console.log(this.disableForm.form.controls + ' ' + this.disableForm.form.disabled); //disable spamming logs

            if (this.disableForm.state) {
                if (this.disableForm.form.disabled === false)
                    this.disableForm.form.disable();
            } else {
                if (this.disableForm.form.disabled === true)
                    this.disableForm.form.enable();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disableForm && changes.disableForm.currentValue.form) {
            if (this.disableForm.state) {
                if (this.disableForm.form.disabled === false)
                    this.disableForm.form.disable();
            } else {
                if (this.disableForm.form.disabled === true)
                    this.disableForm.form.enable();
            }
            // Unsubscribe from previous form status changes
            if (this.statusChangeSubscription) {
                this.statusChangeSubscription.unsubscribe();
            }
        }
    }

    ngOnDestroy(): void {
        // Unsubscribe from form status changes when the directive is destroyed
        this.destroy$.next();
        this.destroy$.complete();
    }
}